/* eslint-disable no-warning-comments */
/* eslint-disable unicorn/no-fn-reference-in-iterator */
/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint-disable default-case */
/* eslint-disable complexity */
/**
 * --------------------------------------------------------------------------
 * weblayout-helpers.js
 * --------------------------------------------------------------------------
 */

import EventHandler from 'bootstrap/js/src/dom/event-handler'
import Waves from 'node-waves';

const DEBUG_STATE = false
const THEME_ID = '#theme'
// Theme settings - only use cookies, no localStorage
let THEME_SETTINGS = {}

// Get the theme cookie name from body data attribute (set by server)
function getThemeCookieName() {
  return document.body?.getAttribute('data-theme-cookie-name') || 'themeSettings';
}

// Debounce utility function
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Function to handle theme preset application
function applyThemePreset(themeName, primary, success, info, warning, danger) {
  // Set all the color data attributes on the body
  document.body.setAttribute('data-bs-theme-primary', primary);
  document.body.setAttribute('data-bs-theme-success', success);
  document.body.setAttribute('data-bs-theme-info', info);
  document.body.setAttribute('data-bs-theme-warning', warning);
  document.body.setAttribute('data-bs-theme-danger', danger);

  // Set CSS custom properties for immediate visual effect
  document.documentElement.style.setProperty('--bs-primary', primary);
  document.documentElement.style.setProperty('--bs-success', success);
  document.documentElement.style.setProperty('--bs-info', info);
  document.documentElement.style.setProperty('--bs-warning', warning);
  document.documentElement.style.setProperty('--bs-danger', danger);

  // Update the color picker form inputs
  const colorInputs = {
    'data-bs-theme-primary': primary,
    'data-bs-theme-success': success,
    'data-bs-theme-info': info,
    'data-bs-theme-warning': warning,
    'data-bs-theme-danger': danger
  };

  Object.entries(colorInputs).forEach(([attr, value]) => {
    const input = document.querySelector(`[data-attribute="${attr}"]`);
    if (input) {
      input.value = value;
    }
  });

  // Update active state of theme preset buttons
  document.querySelectorAll('.theme-preset-btn').forEach(btn => {
    btn.classList.remove('active');
  });

  // Find and activate the current theme button
  const currentThemeBtn = document.querySelector(`[data-theme-name="${themeName}"]`);
  if (currentThemeBtn) {
    currentThemeBtn.classList.add('active');
  }

  // Save settings
  WebLayout.saveSettings();

  if (DEBUG_STATE) {
    console.log(`Applied theme preset: ${themeName}`);
  }
}

// Function to initialize theme preset buttons
function initializeThemePresets() {
  // Add click event listeners to all theme preset buttons
  Array.from(document.querySelectorAll('.theme-preset-btn')).forEach((button) => {
    button.addEventListener('click', function(e) {
      e.preventDefault();

      const themeName = button.getAttribute('data-theme-name');
      const primary = button.getAttribute('data-primary');
      const success = button.getAttribute('data-success');
      const info = button.getAttribute('data-info');
      const warning = button.getAttribute('data-warning');
      const danger = button.getAttribute('data-danger');

      applyThemePreset(themeName, primary, success, info, warning, danger);
    });
  });

  // Handle select elements with data-action-select
  Array.from(document.querySelectorAll('[data-action-select]')).forEach((element) => {
    element.addEventListener('change', function (e) {
      console.log(e);
      let actiontype = element.getAttribute('data-action-select');
      if (!actiontype) return;

      switch (actiontype) {
        case 'set-cookie': {
          var cookieName = element.getAttribute('data-name');
          var cookieValue = element.value;

          // Set the cookie
          setAtheoxCookie(cookieName, cookieValue, 365);

          // Reload the page to apply changes
          location.reload();
          break;
        }
      }
    });
  });

  // Set initial active state based on current colors
  setInitialActiveTheme();
}

// Function to determine which theme is currently active and mark it
function setInitialActiveTheme() {
  const currentPrimary = document.body.getAttribute('data-bs-theme-primary') ||
                        getComputedStyle(document.documentElement).getPropertyValue('--bs-primary').trim();

  if (currentPrimary) {
    const matchingButton = document.querySelector(`[data-primary="${currentPrimary}"]`);
    if (matchingButton) {
      matchingButton.classList.add('active');
    }
  }
}

// Function to get CSS font family value from theme selection
function getFontFamily(fontType) {
  const fontMap = {
    'sans-serif': 'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif',
    'serif': 'Georgia, Cambria, "Times New Roman", Times, serif',
    'monospace': 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", monospace',
    'comic': '"Comic Sans MS", "Chalkboard SE", "Comic Neue", cursive'
  };

  return fontMap[fontType] || fontMap['sans-serif'];
}

function loadThemePresetFromSettings() {
  if (THEME_SETTINGS.page && THEME_SETTINGS.page.activeTheme) {
    const activeTheme = THEME_SETTINGS.page.activeTheme;
    const themeButton = document.querySelector(`[data-theme-name="${activeTheme}"]`);
    if (themeButton) {
      themeButton.classList.add('active');
    }
  }
}

// Debounced color change handler
const debouncedColorChange = debounce((attribute, colorValue) => {
  const propertyMap = {
    'data-bs-theme-primary': '--bs-primary',
    'data-bs-theme-success': '--bs-success',
    'data-bs-theme-warning': '--bs-warning',
    'data-bs-theme-danger': '--bs-danger',
    'data-bs-theme-info': '--bs-info'
  };

  if (attribute) {
    document.body.setAttribute(attribute, colorValue);

    if (propertyMap[attribute]) {
      document.documentElement.style.setProperty(propertyMap[attribute], colorValue);
    }
  }

  WebLayout.saveSettings();
}, 300); // 300ms debounce delay

const WebLayout = {
  // Menu Filter - uses event delegation for Blazor/dynamic content compatibility
  _actionButtonsInitialized: false,
  _actionButtons() {
    // Only attach the document listener once
    if (WebLayout._actionButtonsInitialized) return;
    WebLayout._actionButtonsInitialized = true;

    document.addEventListener('click', function (e) {
      const element = e.target.closest('[data-action]');
      if (!element) return;

      let actiontype = element.getAttribute('data-action');
      if (!actiontype) return;

        switch (actiontype) {
          case 'toggle-sidebar': {
            let target = document.body;
            if (element.getAttribute('data-target')){
              target = document.querySelector(element.getAttribute('data-target'));
            }
            if (target.classList.contains('show')) {
              target.classList.remove('show');
              target.classList.add('hide');
              EventHandler.off(document.querySelector('.page-wrapper'), 'click');
            } else {
              target.classList.remove('hide');
              target.classList.add('show');
              e.preventDefault();
              e.stopPropagation();
              EventHandler.one(document.querySelector('.page-wrapper'), 'click', event => {
                event.preventDefault();
                event.stopPropagation();
                if (target.classList.contains('show')) {
                  target.classList.remove('show');
                  target.classList.add('hide');
                }
              });
            }
            break;
          }

          case 'sticky-sidebar': {
            let target = document.body;
            if (element.getAttribute('data-target')){
              target = document.querySelector(element.getAttribute('data-target'));
            }
            if (target.classList.contains('sidebar-lg')) {
              target.classList.remove('sidebar-lg');
              target.classList.remove('hide');
              target.classList.add('show');
              e.preventDefault();
              e.stopPropagation();
              EventHandler.one(document.querySelector('.page-wrapper'), 'click', event => {
                event.preventDefault();
                event.stopPropagation();
                if (target.classList.contains('show')) {
                  target.classList.remove('show');
                  target.classList.add('hide');
                }
              });
            } else {
              target.classList.add('sidebar-lg');
              EventHandler.off(document.querySelector('.page-wrapper'), 'click');
            }
            break;
          }

          case 'toggle': {
            let target = document.body;
            if (element.getAttribute('data-target')){
              target = document.querySelector(element.getAttribute('data-target'));
            }

            console.log(target);
            const dataClass = element.getAttribute('data-class');

            // Remove previous background image if alternate is selected
            if (dataClass && dataClass.includes('mod-bg-')) {
              const classes = target.className.split(' ');
              classes.forEach(cls => {
                if (cls.startsWith('mod-bg-')) {
                  target.classList.remove(cls);
                }
              });
            }

            // Trigger class change
            if (dataClass) {
              target.classList.toggle(dataClass);
            }

            // Save settings
            WebLayout.saveSettings();
            break;
          }

          case 'apply-theme-preset': {
            const themeName = element.getAttribute('data-theme-name');
            const primary = element.getAttribute('data-primary');
            const success = element.getAttribute('data-success');
            const info = element.getAttribute('data-info');
            const warning = element.getAttribute('data-warning');
            const danger = element.getAttribute('data-danger');

            applyThemePreset(themeName, primary, success, info, warning, danger);
            break;
          }

          case 'toggle-theme': {
            // Check if this is a radio button with a specific theme mode
            const themeMode = element.getAttribute('data-theme-mode');

            if (themeMode) {
              // Radio button with specific mode (light/dark)
              if (themeMode === 'dark') {
                document.body.setAttribute("data-bs-theme", 'dark');
                document.body.classList.remove('dark');
              } else {
                document.body.setAttribute("data-bs-theme", 'default');
                document.body.classList.add('dark');
              }
            } else {
              // Regular toggle (for header icons)
              let currentTheme = document.body.getAttribute("data-bs-theme");
              if (currentTheme === 'dark') {
                document.body.setAttribute("data-bs-theme", 'default');
                document.body.classList.add('dark');
              } else {
                document.body.setAttribute("data-bs-theme", 'dark');
                document.body.classList.remove('dark');
              }
            }
            WebLayout.saveSettings();
            break;
          }

          case 'save-theme': {
            WebLayout.saveSettings(true);
            break;
          }

          case 'reset-theme': {
            WebLayout.resetSettings(true);
            break;
          }

          case 'color-change': {
            const attribute = element.getAttribute('data-attribute');
            const colorValue = element.value;

            // Use debounced function for color changes
            debouncedColorChange(attribute, colorValue);
            break;
          }

          case 'radius-change': {
            const attribute = element.getAttribute('data-attribute');
            const radiusValue = element.value;

            if (attribute) {
              // Set data attribute for saving
              document.body.setAttribute(attribute, radiusValue);

              // Set CSS custom property for immediate visual effect
              document.documentElement.style.setProperty('--bs-border-radius-scale', radiusValue);
            }

            // Update the display value
            const radiusDisplay = document.getElementById('radius-value');
            if (radiusDisplay) {
              radiusDisplay.textContent = radiusValue;
            }

            WebLayout.saveSettings();
            break;
          }

          case 'font-change': {
            const fontValue = element.value;

            // Apply font family to the document root
            document.documentElement.style.setProperty('--bs-body-font-family', getFontFamily(fontValue));
            document.body.setAttribute('data-bs-theme-font', fontValue);

            WebLayout.saveSettings();
            break;
          }

          case 'theme-base-change': {
            const baseValue = element.value;

            // Remove existing theme base classes
            document.body.classList.remove('theme-base-slate', 'theme-base-gray', 'theme-base-zinc', 'theme-base-neutral', 'theme-base-stone');

            // Add new theme base class
            document.body.classList.add(`theme-base-${baseValue}`);

            // Set the data-bs-theme-base attribute
            document.body.setAttribute('data-bs-theme-base', baseValue);

            WebLayout.saveSettings();
            break;
          }

          case 'corner-radius-change': {
            const radiusValue = element.value;

            // Set data attribute for saving
            document.body.setAttribute('data-bs-theme-radius', radiusValue);

            // Set CSS custom property for immediate visual effect
            document.documentElement.style.setProperty('--bs-border-radius-scale', radiusValue);

            // Update the slider value if it exists
            const radiusSlider = document.querySelector('input[data-attribute="data-bs-theme-radius"]');
            if (radiusSlider) {
              radiusSlider.value = radiusValue;
            }

            // Update the display value
            const radiusDisplay = document.getElementById('radius-value');
            if (radiusDisplay) {
              radiusDisplay.textContent = radiusValue;
            }

            WebLayout.saveSettings();
            break;
          }

          case 'reset-colors': {
            const defaultColors = {
              'data-bs-theme-primary': '#0d6efd',
              'data-bs-theme-success': '#198754',
              'data-bs-theme-warning': '#ffc107',
              'data-bs-theme-danger': '#dc3545',
              'data-bs-theme-info': '#0dcaf0',
              'data-bs-theme-base': '#ffffff',
              'data-bs-theme-radius': '1'
            };

            const cssPropertyMap = {
              'data-bs-theme-primary': '--bs-primary',
              'data-bs-theme-success': '--bs-success',
              'data-bs-theme-warning': '--bs-warning',
              'data-bs-theme-danger': '--bs-danger',
              'data-bs-theme-info': '--bs-info',
              'data-bs-theme-radius': '--bs-border-radius-scale'
            };

            // Reset body attributes and CSS custom properties
            Object.entries(defaultColors).forEach(([attr, value]) => {
              document.body.setAttribute(attr, value);

              if (cssPropertyMap[attr]) {
                document.documentElement.style.setProperty(cssPropertyMap[attr], value);
              }
            });

            // Reset form inputs
            Object.entries(defaultColors).forEach(([attr, value]) => {
              const input = document.querySelector(`[data-attribute="${attr}"]`);
              if (input) {
                input.value = value;

                if (attr === 'data-bs-theme-radius') {
                  const radiusDisplay = document.getElementById('radius-value');
                  if (radiusDisplay) {
                    radiusDisplay.textContent = value;
                  }
                }
              }
            });

            WebLayout.saveSettings();
            break;
          }

          case 'toggle-theme-dark': {
            // Clear any cached settings
            THEME_SETTINGS = {};

            // Send change to server API to set cookie properly
            fetch('/api/themes/update', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ darkMode: true })
            }).then(() => {
              // Reload to ensure server state is applied and cache is cleared
              location.reload();
            });
            break;
          }

          case 'toggle-theme-default': {
            // Clear any cached settings
            THEME_SETTINGS = {};

            // Send change to server API to set cookie properly
            fetch('/api/themes/update', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ darkMode: false })
            }).then(() => {
              // Reload to ensure server state is applied and cache is cleared
              location.reload();
            });
            break;
          }

          case 'toggle-swap': {
            let target = document.body;
            if (element.getAttribute('data-target')){
              target = document.querySelector(element.getAttribute('data-target'));
            }

            const targetElement = document.querySelector(element.getAttribute('data-target'));
            if (targetElement) {
              targetElement.className = '';
              target.classList.add(element.getAttribute('data-class'));
            }
            break;
          }

          case 'toggle-replace': {
            let target = document.body;
            if (element.getAttribute('data-target')){
              target = document.querySelector(element.getAttribute('data-target'));
            }
            const replaceClass = element.getAttribute('data-replaceclass');
            const dataClass = element.getAttribute('data-class') || '';

            // Remove replace classes
            if (replaceClass) {
              const classes = replaceClass.split(' ');
              classes.forEach(cls => {
                if (cls.trim()) {
                  target.classList.remove(cls.trim());
                }
              });
            }

            // Add new class
            if (dataClass) {
              target.classList.add(dataClass);
            }

            WebLayout.saveSettings();
            break;
          }

          case 'toggle-replace-swap': {
            let target = document.body;
            if (element.getAttribute('data-target')){
              target = document.querySelector(element.getAttribute('data-target'));
            }
            const replaceClass = element.getAttribute('data-replaceclass') || '';
            const dataClass = element.getAttribute('data-class') || '';
            const removeClass = element.getAttribute('data-removeclass') || '';

            let haveValues = false;

            // Check if target has any of the data classes
            if (dataClass) {
              const classes = dataClass.split(' ');
              haveValues = classes.some(cls => cls.trim() && target.classList.contains(cls.trim()));
            }

            if (haveValues) {
              // Remove data classes and add replace classes
              if (dataClass) {
                const classes = dataClass.split(' ');
                classes.forEach(cls => {
                  if (cls.trim()) {
                    target.classList.remove(cls.trim());
                  }
                });
              }

              if (replaceClass) {
                const classes = replaceClass.split(' ');
                classes.forEach(cls => {
                  if (cls.trim()) {
                    target.classList.add(cls.trim());
                  }
                });
              }
            } else {
              // Remove replace classes and add data classes
              if (replaceClass) {
                const classes = replaceClass.split(' ');
                classes.forEach(cls => {
                  if (cls.trim()) {
                    target.classList.remove(cls.trim());
                  }
                });
              }

              if (dataClass) {
                const classes = dataClass.split(' ');
                classes.forEach(cls => {
                  if (cls.trim()) {
                    target.classList.add(cls.trim());
                  }
                });
              }
            }

            // Always remove removeClass
            if (removeClass) {
              const classes = removeClass.split(' ');
              classes.forEach(cls => {
                if (cls.trim()) {
                  target.classList.remove(cls.trim());
                }
              });
            }

            // Save sidebar state via API if target is a sidebar element
            // Don't call saveSettings() here - saveSidebarState handles the cookie update
            if (target.id && target.classList.contains('sidebar')) {
              WebLayout.saveSidebarState(target.id, target.className);
            } else {
              // Only save general settings for non-sidebar toggles
              WebLayout.saveSettings();
            }
            break;
          }

          case 'theme-update': {
            const themeElement = document.querySelector(THEME_ID);
            if (themeElement) {
              themeElement.setAttribute('href', element.getAttribute('data-theme'));
            } else {
              const existingTheme = document.getElementById('theme');
              if (existingTheme) {
                existingTheme.remove();
              }

              const themeelement = document.createElement('link');
              themeelement.id = THEME_ID.replace('#', '');
              themeelement.rel = 'stylesheet';
              themeelement.href = element.getAttribute('data-theme');
              document.querySelector('head').appendChild(themeelement);
            }

            if (element.getAttribute('data-themesave') !== undefined) {
              WebLayout.saveSettings();
            }

            // Remove the active class from all elements that have the 'active' class
            document.querySelectorAll('[data-action="theme-update"]').forEach((el) => {
              el.classList.remove('active');
            });

            // Add the active class to the current element
            element.classList.add('active');
            break;
          }

          case 'app-print': {
            window.print();
            break;
          }

          case 'toggle-language': {
            setAtheoxCookie('lang', element.getAttribute('data-language').toString(), 365);
            location.reload();
            break;
          }

          case 'set-cookie': {
            setAtheoxCookie(
              element.getAttribute('data-name').toString(),
              element.getAttribute('data-value').toString(),
              365
            );
            break;
          }

          case 'app-fullscreen': {
            if (
              !document.fullscreenElement &&
              !document.mozFullScreenElement &&
              !document.webkitFullscreenElement &&
              !document.msFullscreenElement
            ) {
              if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
              } else if (document.documentElement.msRequestFullscreen) {
                document.documentElement.msRequestFullscreen();
              } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
              } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
              }

              if (DEBUG_STATE) {
                console.log('app fullscreen toggle active');
              }
            } else {
              if (document.exitFullscreen) {
                document.exitFullscreen();
              } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
              } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
              } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
              }

              if (DEBUG_STATE) {
                console.log('%capp fullscreen toggle inactive!', 'color: #ed1c24');
              }
            }
            break;
          }
        }

      if (DEBUG_STATE) {
        console.log('data-action clicked: ' + actiontype);
      }
    });

    // Event delegation for color inputs
    document.addEventListener('input', function (e) {
      const element = e.target.closest('input[type="color"][data-action="color-change"]');
      if (!element) return;

      const attribute = element.getAttribute('data-attribute');
      const colorValue = element.value;

      // Apply color change immediately for visual feedback
      const propertyMap = {
        'data-bs-theme-primary': '--bs-primary',
        'data-bs-theme-success': '--bs-success',
        'data-bs-theme-warning': '--bs-warning',
        'data-bs-theme-danger': '--bs-danger',
        'data-bs-theme-info': '--bs-info'
      };

      if (attribute) {
        document.body.setAttribute(attribute, colorValue);

        if (propertyMap[attribute]) {
          document.documentElement.style.setProperty(propertyMap[attribute], colorValue);
        }
      }

      // Use debounced function for saving settings
      debouncedColorChange(attribute, colorValue);
    });

    // Event delegation for range inputs
    document.addEventListener('input', function (e) {
      const element = e.target.closest('input[type="range"][data-action="radius-change"]');
      if (!element) return;

      const attribute = element.getAttribute('data-attribute');
      const radiusValue = element.value;

      if (attribute) {
        document.body.setAttribute(attribute, radiusValue);
        document.documentElement.style.setProperty('--bs-border-radius-scale', radiusValue);
      }

      const radiusDisplay = document.getElementById('radius-value');
      if (radiusDisplay) {
        radiusDisplay.textContent = radiusValue;
      }

      WebLayout.saveSettings();
    });

    // Event delegation for radio button changes
    document.addEventListener('change', function (e) {
      const element = e.target.closest('input[type="radio"][data-action]');
      if (!element || !element.checked) return;

      const actiontype = element.getAttribute('data-action');

      switch (actiontype) {
        case 'font-change': {
          const fontValue = element.value;
          document.documentElement.style.setProperty('--bs-body-font-family', getFontFamily(fontValue));
          document.body.setAttribute('data-bs-theme-font', fontValue);
          WebLayout.saveSettings();
          break;
        }

        case 'theme-base-change': {
          const baseValue = element.value;

          // Remove existing theme base classes
          document.body.classList.remove('theme-base-slate', 'theme-base-gray', 'theme-base-zinc', 'theme-base-neutral', 'theme-base-stone');

          // Add new theme base class
          document.body.classList.add(`theme-base-${baseValue}`);

          // Set the data-bs-theme-base attribute
          document.body.setAttribute('data-bs-theme-base', baseValue);

          WebLayout.saveSettings();
          break;
        }

        case 'corner-radius-change': {
          const radiusValue = element.value;

          document.body.setAttribute('data-bs-theme-radius', radiusValue);
          document.documentElement.style.setProperty('--bs-border-radius-scale', radiusValue);

          const radiusSlider = document.querySelector('input[data-attribute="data-bs-theme-radius"]');
          if (radiusSlider) {
            radiusSlider.value = radiusValue;
          }

          const radiusDisplay = document.getElementById('radius-value');
          if (radiusDisplay) {
            radiusDisplay.textContent = radiusValue;
          }

          WebLayout.saveSettings();
          break;
        }
      }
    });
  },

  resetSettings(refresh = false) {
    // Clear any client-side cache
    THEME_SETTINGS = {};

    // Also try to delete cookie client-side for immediate effect
    deleteAtheoxCookie(getThemeCookieName());

    // Call server API to reset theme (which will also delete cookie server-side)
    fetch('/api/themes/reset', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    }).then(() => {
      // Always reload to ensure server state is applied
      // This clears any cached state and gets fresh defaults
      location.reload();
    }).catch(err => {
      console.error('Failed to reset theme:', err);
      // Even on error, reload to try to get clean state
      location.reload();
    });
  },

  saveSettings(refresh = false) {
    // Collect form data
    const form = document.getElementById('layoutSettings');
    let data = {};

    if (form) {
      data = Object.fromEntries(new FormData(form).entries());
    }

    // Build layoutBodyClass from global mods and accessibility settings
    let layoutBodyClass = "";

    if (data.modCleanBackground === "on"){
      layoutBodyClass = layoutBodyClass + " mod-clean-page-bg";
    }

    if (data.modColorBlind === "on"){
      layoutBodyClass = layoutBodyClass + " mod-color-blind";
    }

    if (data.modDisableAnimations === "on"){
      layoutBodyClass = layoutBodyClass + " mod-disable-animation";
    }

    if (data.modHideInfoCard === "on"){
      layoutBodyClass = layoutBodyClass + " mod-hide-info-card";
    }

    if (data.modNavIcons === "on"){
      layoutBodyClass = layoutBodyClass + " mod-hide-nav-icons";
    }

    if (data.modHightContrast === "on"){
      layoutBodyClass = layoutBodyClass + " mod-high-contrast";
    }

    if (data.modNavLink === "on"){
      layoutBodyClass = layoutBodyClass + " mod-nav-link";
    }

    if (data.modBoxShadow === "on"){
      layoutBodyClass = layoutBodyClass + " mod-box-shadow";
    }

    if (data.modBiggerFont === "on"){
      layoutBodyClass = layoutBodyClass + " mod-bigger-font";
    }

    // Build the settings object to send to server
    const settings = {
      page: {
        layout: data.layout || 'default',
        darkMode: document.body.getAttribute("data-bs-theme") === 'dark',
        layoutBodyClass: layoutBodyClass,

        // Colors - safe to send
        bsThemePrimary: document.body.getAttribute("data-bs-theme-primary") || '#0d6efd',
        bsThemeSuccess: document.body.getAttribute("data-bs-theme-success") || '#198754',
        bsThemeWarning: document.body.getAttribute("data-bs-theme-warning") || '#ffc107',
        bsThemeDanger: document.body.getAttribute("data-bs-theme-danger") || '#dc3545',
        bsThemeInfo: document.body.getAttribute("data-bs-theme-info") || '#0dcaf0',

        // Advanced styling - safe to send
        bsThemeFont: document.body.getAttribute('data-bs-theme-font') || 'sans-serif',
        bsThemeBase: document.body.getAttribute('data-bs-theme-base') || 'slate',
        bsThemeBorderRadius: document.body.getAttribute('data-bs-theme-radius') || '1',

        hideTopbar: data.hideTopbar === "on",
        sidebarDark: data.sidebarDark === "on",
        sidebarPrimary: data.sidebarPrimary === "on",
        sidebarHeaderPrimary: data.sidebarHeaderPrimary === "on"
      },
      navbar: {
        sticky: data.navbarSticky === "on",
        hideSearch: data.navbarHideSearch === "on",
        dark: data.navbarDark === "on",
        primaryColor: data.navbarPrimary === "on"
      }
    };

    // Send to server - it will handle SetLayout and merging
    fetch("/api/themes/options", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Theme-Cookie': getThemeCookieName()
      },
      body: JSON.stringify(settings),
    }).then((response) => {
      if (refresh){
        location.reload();
      }
    }).catch(e => {
      console.warn('Error saving to API:', e);
      if (refresh){
        location.reload();
      }
    });

      if (DEBUG_STATE) {
        console.log('Theme settings saved to cookie');
      }
  },

  // Save sidebar state via API (stored in themeSettings cookie)
  saveSidebarState(sidebarId, classNames) {
    if (!sidebarId) return;

    // Extract only the persistent sidebar state classes (not transient responsive classes)
    // sidebar-lg-show is a transient class used by toggle mechanism, not a persistent state
    const stateClasses = ['sidebar-minimized', 'sidebar-narrow-unfoldable'];
    const activeStates = stateClasses.filter(cls => classNames.includes(cls));

    // Save via API - will be stored in themeSettings cookie
    fetch('/api/themes/sidebar-state', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Theme-Cookie': getThemeCookieName()
      },
      body: JSON.stringify({
        sidebarId: sidebarId,
        stateClasses: activeStates.join(' ')
      })
    }).then(response => {
      if (DEBUG_STATE) {
        console.log(`Saved sidebar state for ${sidebarId}:`, activeStates);
      }
    }).catch(e => {
      console.warn('Error saving sidebar state:', e);
    });
  },

  _detectOSDarkMode() {
    // Check if OS detection is enabled (set by server as data attribute)
    if (document.body.getAttribute('data-os-dark-mode-detection') !== 'true') return;

    // Only detect if no user preference cookie exists
    if (document.cookie.includes(getThemeCookieName() + '=')) return;

    // Check if browser supports media queries
    if (!window.matchMedia) return;

    // Detect OS dark mode preference
    const darkModeQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const osDarkMode = darkModeQuery.matches;

    // Get current page state
    const currentDarkMode = document.body.getAttribute('data-bs-theme') === 'dark';

    // If OS preference differs from current state, just apply it directly
    if (osDarkMode !== currentDarkMode) {
      // Apply OS preference immediately without API call
      document.body.setAttribute('data-bs-theme', osDarkMode ? 'dark' : 'default');

      // Note: This is temporary until user sets their own preference
      // No cookie is set, so OS preference will be re-detected on each page load
    }
  },

  _loadSettings() {
    // Check for OS dark mode preference if no user preference exists
    this._detectOSDarkMode();

    // Don't apply cached settings - let server handle everything
    return;

      if (THEME_SETTINGS.bodyMods) {
        document.body.className = THEME_SETTINGS.bodyMods;
        console.log('%c✔ Theme settings loaded', "color: #148f32");
      } else {
        console.log('%c✔ Heads up! Theme settings is empty or does not exist, loading default settings...', 'color: #ed1c24');
      }

      if (THEME_SETTINGS.themeCss && !document.getElementById('theme')) {
        const cssfile = document.createElement('link');
        cssfile.id = 'theme';
        cssfile.rel = 'stylesheet';
        cssfile.href = THEME_SETTINGS.themeCss;
        document.getElementsByTagName('head')[0].appendChild(cssfile);
      } else if (THEME_SETTINGS.themeCss && document.getElementById('theme')) {
        document.getElementById('theme').href = THEME_SETTINGS.themeCss;
      }

      // Load color theme settings and apply them to both data attributes and CSS custom properties
      if (THEME_SETTINGS.page) {
        const colorMap = {
          'bsThemePrimary': { attr: 'data-bs-theme-primary', cssVar: '--bs-primary' },
          'bsThemeSuccess': { attr: 'data-bs-theme-success', cssVar: '--bs-success' },
          'bsThemeWarning': { attr: 'data-bs-theme-warning', cssVar: '--bs-warning' },
          'bsThemeDanger': { attr: 'data-bs-theme-danger', cssVar: '--bs-danger' },
          'bsThemeInfo': { attr: 'data-bs-theme-info', cssVar: '--bs-info' },
          'bsThemeBase': { attr: 'data-bs-theme-base', cssVar: null },
          'bsThemeBorderRadius': { attr: 'data-bs-theme-radius', cssVar: '--bs-border-radius-scale' }
        };

        Object.entries(colorMap).forEach(([settingKey, config]) => {
          if (THEME_SETTINGS.page[settingKey]) {
            // Set data attribute
            document.body.setAttribute(config.attr, THEME_SETTINGS.page[settingKey]);

            // Set CSS custom property if defined
            if (config.cssVar) {
              document.documentElement.style.setProperty(config.cssVar, THEME_SETTINGS.page[settingKey]);
            }
          }
        });

        // Load color picker form values
        Object.entries(colorMap).forEach(([settingKey, config]) => {
          if (THEME_SETTINGS.page[settingKey]) {
            const input = document.querySelector(`[data-attribute="${config.attr}"]`);
            if (input) {
              input.value = THEME_SETTINGS.page[settingKey];

              if (config.attr === 'data-bs-theme-radius') {
                // Update radius display
                const radiusDisplay = document.getElementById('radius-value');
                if (radiusDisplay) {
                  radiusDisplay.textContent = THEME_SETTINGS.page[settingKey];
                }
              }
            }
          }
        });

        // Load font and styling settings
        if (THEME_SETTINGS.page.bsThemeFont) {
          document.documentElement.style.setProperty('--bs-body-font-family', getFontFamily(THEME_SETTINGS.page.bsThemeFont));
          document.body.setAttribute('data-bs-theme-font', THEME_SETTINGS.page.bsThemeFont);

          // Update radio button selection
          const fontRadio = document.querySelector(`input[name="theme-font"][value="${THEME_SETTINGS.page.bsThemeFont}"]`);
          if (fontRadio) {
            fontRadio.checked = true;
          }
        }

        if (THEME_SETTINGS.page.bsThemeBase) {
          document.body.classList.add(`theme-base-${THEME_SETTINGS.page.bsThemeBase}`);
          document.body.setAttribute('data-bs-theme-base', THEME_SETTINGS.page.bsThemeBase);

          // Update radio button selection
          const baseRadio = document.querySelector(`input[name="theme-base"][value="${THEME_SETTINGS.page.bsThemeBase}"]`);
          if (baseRadio) {
            baseRadio.checked = true;
          }
        }

        if (THEME_SETTINGS.page.bsThemeBorderRadius) {
          document.documentElement.style.setProperty('--bs-border-radius-scale', THEME_SETTINGS.page.bsThemeBorderRadius);
          document.body.setAttribute('data-bs-theme-radius', THEME_SETTINGS.page.bsThemeBorderRadius);

          // Update radio button selection
          const radiusRadio = document.querySelector(`input[name="theme-radius-preset"][value="${THEME_SETTINGS.page.bsThemeBorderRadius}"]`);
          if (radiusRadio) {
            radiusRadio.checked = true;
          }
        }
      }
  },

  accessIndicator() {
    document.body.classList.add('saving');
    setTimeout(() => {
      document.body.classList.remove('saving');
    }, 600);
  },

  // Menu Filter
  _navbarFilterInit() {
    const list = document.getElementById('sidebar');
    const input = document.getElementById('sidebar-nav-filter-input');
    const anchor = document.getElementById('sidebar-nav');

    if (!list || !input) {
      return;
    }

    // Add class to filter hide/show
    if (anchor) {
      anchor.classList.add('js-list-filter');
    } else {
      list.classList.add('js-list-filter');
    }

    // On change keyboard
    input.addEventListener('keyup', function() {
      const filter = this.value.toLowerCase();
      const listPrev = list.nextElementSibling;
      const isFilterMessage = listPrev && listPrev.classList.contains('js-filter-message');

      // When user types more than 1 letter start search filter
      if (filter.length > 1) {
        // Hide all that does not match
        const nonMatchingElements = list.querySelectorAll(`[data-filter-tags]:not([data-filter-tags*='${filter}'])`);
        nonMatchingElements.forEach(el => {
          let parent = el.parentElement;
          while (parent && parent !== list) {
            parent.classList.remove('js-filter-show');
            parent.classList.add('js-filter-hide');
            parent = parent.parentElement;
          }
        });

        // Show all that does match
        const matchingElements = list.querySelectorAll(`[data-filter-tags*='${filter}']`);
        matchingElements.forEach(el => {
          let parent = el.parentElement;
          while (parent && parent !== list) {
            parent.classList.remove('js-filter-hide');
            parent.classList.add('js-filter-show');
            parent = parent.parentElement;
          }
        });

        // If element exists then print results
        if (isFilterMessage) {
          const totalElements = list.querySelectorAll('[data-filter-tags]').length;
          const visibleElements = list.querySelectorAll('li.js-filter-show').length;
          listPrev.textContent = `showing ${visibleElements} from ${totalElements} total`;
        }
      } else {
        // When filter length is blank reset the classes
        const filterElements = list.querySelectorAll('[data-filter-tags]');
        filterElements.forEach(el => {
          let parent = el.parentElement;
          while (parent && parent !== list) {
            parent.classList.remove('js-filter-hide', 'js-filter-show');
            parent = parent.parentElement;
          }
        });

        // If element exists reset print results
        if (isFilterMessage) {
          listPrev.textContent = '';
        }
      }
    });
  },

  // Waves effect on menu
  _nodeWaves() {
    try {
      // Check if Waves is available
      if (typeof Waves !== 'undefined') {
        Waves.attach('.sidebar-nav:not(.js-waves-off) a, .btn:not(.js-waves-off):not(.btn-switch), .js-waves-on', ['waves-themed']);
        Waves.init();
      }
    } catch (e) {
      console.warn('Waves effect could not be initialized:', e);
    }
  }
};

function getAtheoxCookie(name) {
  try {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  } catch (e) {
    console.warn('Error getting cookie:', e);
    return null;
  }
}

function encodeToBase64(str) {
  try {
    // Use standard base64 encoding to match server
    return btoa(str);
  } catch (e) {
    console.warn('Error encoding to base64:', e);
    return str;
  }
}

function decodeFromBase64(str) {
  try {
    // Check if it's already decoded JSON
    if (str.startsWith('{') || str.startsWith('[')) {
      return str;
    }

    // Standard base64 decode (matching server format)
    return atob(str);
  } catch (e) {
    console.warn('Error decoding from base64:', e);
    return str;
  }
}

function setAtheoxCookie(name, value, days) {
  try {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  } catch (e) {
    console.warn('Error setting cookie:', e);
  }
}

function deleteAtheoxCookie(name) {
  try {
    const expires = "expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = name + "=;" + expires + ";path=/";
  } catch (e) {
    console.warn('Error deleting cookie:', e);
  }
}

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', (event) => {
  try {
    WebLayout._loadSettings();
    WebLayout._actionButtons();
    WebLayout._nodeWaves();
    initializeThemePresets();
    loadThemePresetFromSettings();

    // Only initialize navbar filter if jQuery is available
    if (typeof window.jQuery !== 'undefined') {
      WebLayout._navbarFilterInit();
    }

  } catch (e) {
    console.error('Error initializing WebLayout:', e);
  }
});

// Export for use in other modules
if (typeof module !== 'undefined' && module.exports) {
  module.exports = WebLayout;
} else if (typeof window !== 'undefined') {
  window.WebLayout = WebLayout;
}